module.exports = __webpack_public_path__ + "media/Tijdmachine_1_mobiel_420.mp4";